import React from 'react';
import { PropTypes } from 'prop-types';
import { isEmpty } from 'lodash';
import cx from 'classnames';
import { Icon } from '@unite-us/ui';

const BaseTimelineEvent = ({
  className, icon, message, date, eventDetails, shouldDisplayIconDivider,
}) => (
  <li className={className}>
    <div className="relative">
      <div className="flex items-start gap-2">
        {shouldDisplayIconDivider && (
          <div className="absolute left-0 top-0 ml-3 h-full w-0.5" aria-hidden="true">
            <div className="bg-dark-fill-blue mt-6 w-full h-full" />
          </div>
        )}
        <div
          className={cx(
            'bg-dark-fill-blue',
            'h-6 w-6 rounded-full flex items-center justify-center',
          )}
        >
          <Icon
            color="currentColor"
            className="text-dark-grey"
            icon={isEmpty(icon) ? 'IconPencil' : icon}
            size={14}
          />
        </div>
        <div className="flex flex-col gap-0">
          <div className="mt-0 leading-6">{message}</div>
          {!isEmpty(eventDetails) && (
            <div className="min-w-0 flex-1 flex justify-between space-x-12 space-y-0">
              {eventDetails}
            </div>
          )}
        </div>
        <div className="flex-shrink-0 ml-auto text-right text-sm whitespace-nowrap text-dark-grey">
          {date}
        </div>
      </div>
    </div>
  </li>
);

BaseTimelineEvent.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  eventDetails: PropTypes.node,
  shouldDisplayIconDivider: PropTypes.bool,
};

BaseTimelineEvent.defaultProps = {
  className: 'mb-4',
  eventDetails: [],
  shouldDisplayIconDivider: true,
};

export default BaseTimelineEvent;
